import { a as a$1 } from './chunk-YXAAPN2W.mjs';
import { a as a$2 } from './chunk-E4ZRBNNU.mjs';
import { d as d$1 } from './chunk-6EFRS222.mjs';
import { b } from './chunk-26IU2X5T.mjs';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import t, { css } from 'styled-components';
import { Root, Indicator } from '@radix-ui/react-checkbox';
import { jsx, jsxs } from 'react/jsx-runtime';

var u=t(d$1).attrs({size:"regular"})``,o=t(d$1).attrs({size:"small"})`
  color: var(--foreground-tertiary);
`,e=t(Root)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  height: var(--spacing-regular);
  width: var(--spacing-regular);
  margin-top: 2px;
  // Donot update without prior design discussion
  border-radius: 3px;
  outline: none;
  border: var(--border-width-small) solid var(--border-boolean-default);
  background: none;

  &[data-state='checked'] {
    border: var(--border-width-small) solid
      var(--background-interactive-active-default);
  }
`,a=t(Indicator)`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  color: var(--foreground-inverse);
  background-color: var(--background-interactive-active-default);
`,d=t.label`
  display: block;
  padding: var(--spacing-small);
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-regular);
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`,L=css`
  border: var(--border-width-x-small) solid var(--border-error);

  ${d} {
    color: var(--foreground-primary);
  }

  ${o} {
    color: var(--foreground-tertiary);
  }

  ${a} {
    background-color: var(--background-interactive-error-default);
  }

  ${e} {
    border: var(--border-width-small) solid var(--foreground-error);

    &[data-state='checked'] {
      border: var(--border-width-small) solid
        var(--background-interactive-error-default);
    }
  }

  &:hover {
    border: var(--border-width-x-small) solid var(--border-boolean-error-hover);
    background: none;

    ${d} {
      color: var(--foreground-primary);
    }

    ${o} {
      color: var(--foreground-tertiary);
    }

    ${a} {
      background-color: var(--border-boolean-error-hover);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-boolean-error-hover);

      &[data-state='checked'] {
        border: var(--border-width-small) solid
          var(--border-boolean-error-hover);
      }
    }
  }

  &:focus-within {
    border: var(--border-width-x-small) solid var(--border-input-error);
    box-shadow: 0 0 0 var(--border-width-small)
      var(--border-input-error-outline);
  }
`,W=css`
  cursor: not-allowed;

  ${d} {
    color: var(--foreground-disabled);
    cursor: not-allowed;
  }

  ${o} {
    color: var(--foreground-disabled);
  }

  ${e} {
    border: var(--border-width-small) solid var(--border-input-disabled);

    &[data-state='checked'] {
      border: var(--border-width-small) solid var(--background-disabled);
    }
  }

  ${a} {
    background-color: var(--background-disabled);
  }

  &:hover {
    background: none;

    ${d} {
      color: var(--foreground-disabled);
    }

    ${a} {
      background-color: var(--background-disabled);
    }

    ${o} {
      color: var(--foreground-disabled);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-input-disabled);

      &[data-state='checked'] {
        border: var(--border-width-small) solid var(--background-disabled);
      }
    }
  }
`,g=t.div`
  border: var(--border-width-x-small) solid transparent;
  border-radius: var(--spacing-small);

  ${({$fullWidth:r})=>!r&&"max-width: 320px;"}
  width: 100%;

  &:hover {
    background-color: var(--background-boolean-hover);

    ${d} {
      color: var(--foreground-primary);
    }

    ${a} {
      background-color: var(--background-interactive-active-hover);
    }

    ${o} {
      color: var(--foreground-secondary);
    }

    ${e} {
      border: var(--border-width-small) solid var(--border-boolean-hover);

      &[data-state='checked'] {
        border: var(--border-width-small) solid
          var(--background-interactive-active-hover);
      }
    }
  }

  &:focus-within {
    border: var(--border-width-x-small) solid var(--border-boolean-active-hover);
    box-shadow: 0 0 0 var(--border-width-small)
      var(--border-input-active-outline);
  }

  ${({$error:r})=>r&&L}
  ${({$disabled:r})=>r&&W}
`;var i=({id:r,children:m,error:f=!1,checked:c=!1,disabled:s=!1,fullWidth:k=!1,spacing:x="small",yAlign:w="flex-start",onCheckedChange:y,...$})=>jsx(g,{$error:f,$disabled:s,$fullWidth:k,children:jsx(d,{htmlFor:r,children:jsxs(a$1,{yAlign:w,spacing:x,children:[jsx(e,{id:r,disabled:s,checked:c,onCheckedChange:y,role:"checkbox","aria-checked":c,...$,children:jsx(a,{children:jsx(b,{icon:faCheck,size:"small","aria-hidden":"true"})})}),jsx(a$2,{spacing:"none",children:m})]})})});i.displayName="Checkbox";i.Label=u;i.Description=o;var D=t(i)``;

export { D as a };
